import { render, staticRenderFns } from "./PostUserTable.vue?vue&type=template&id=3d058d8b&scoped=true&"
import script from "./PostUserTable.vue?vue&type=script&lang=js&"
export * from "./PostUserTable.vue?vue&type=script&lang=js&"
import style0 from "./PostUserTable.vue?vue&type=style&index=0&id=3d058d8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d058d8b",
  null
  
)

export default component.exports